module.exports = __webpack_public_path__ + "img/connection_group_24px.bbe999a0.svg";